// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__vJM-P","toggleWrap":"styles_toggleWrap__1R2ir","content":"styles_content__3X8qG","selectAreaCode":"styles_selectAreaCode__1--S4"};